import { render, staticRenderFns } from "./RadioInnerButton.vue?vue&type=template&id=2fb3c25c"
import script from "./RadioInnerButton.vue?vue&type=script&lang=ts"
export * from "./RadioInnerButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports